/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Layout, message, Row } from 'antd'
import { Helmet } from 'react-helmet'
import { useEffect, useState } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { useHistory, useLocation } from 'react-router-dom'
import { Main, StyledLayout } from './Profile.styles'
import { PlanBilling, UserDetailForm, PaymentForm } from '../../components'
import {
    fetchSaveSubscriptionCancel,
    fetchSaveSubscriptionSuccess,
    fetchSubscriptionConfig,
} from '../../utils'
import { STRIPE_PUBLISH_KEY } from '../../utils/consts'
import { useAppSelector } from '../../store/hooks'
import { ISaveUser } from '../../utils/types'

const { Content } = Layout

const Profile: React.FC = () => {
    const user = useAppSelector((state) => state.user!)
    const [clientSecret, setClientSecret] = useState('')
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [subscriptionId, setSubscriptionId] = useState('')
    const [stripePromise, setStripePromise] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    const history = useHistory()
    const { search } = useLocation<any>()

    useEffect(() => {
        setStripePromise(
            new Promise((resolve) => {
                setTimeout(() => {
                    loadStripe(STRIPE_PUBLISH_KEY.DEV).then((res) => {
                        setIsLoading(false)
                        return resolve(res)
                    })
                }, 2000)
            }) as any
        )
    }, [])

    useEffect(() => {
        const queryParams = new URLSearchParams(search)
        const paymentIntentSecret = queryParams.get(
            'payment_intent_client_secret'
        )
        const paymentIntentId = queryParams.get('payment_intent')
        const status = queryParams.get('redirect_status')

        if (paymentIntentSecret && paymentIntentId && status === 'succeeded') {
            // call it's subscribed successfully
            setIsLoading(true)
            fetchSaveSubscriptionSuccess(
                paymentIntentSecret,
                paymentIntentId,
                user as unknown as ISaveUser
            ).then(() => {
                setIsLoading(false)
                message.success('Subscribed Successfully')
                history.replace('/profile')
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search])

    const handleCancelSubscription = () => {
        setIsLoading(true)
        fetchSaveSubscriptionCancel(user as unknown as ISaveUser).then(() => {
            message.success('Cancelled Subscription Successfully')
            setStripePromise(null)
            setClientSecret('')
            setTimeout(() => {
                window.location.reload()
            }, 3000)
        })
    }
    const handlePreSubscription = () => {
        setIsLoading(true)
        fetchSubscriptionConfig().then(
            ({
                clientSecret: _clientSecret,
                subscriptionId: _subscriptionId,
            }) => {
                setClientSecret(_clientSecret)
                setSubscriptionId(_subscriptionId)
                setIsLoading(false)
            }
        )
    }

    return (
        <StyledLayout>
            <Helmet title="Profile" />
            <Content style={{ padding: '0 50px' }}>
                <Row justify="center" gutter={[16, 16]}>
                    <Col span={16}>
                        <Main>
                            <UserDetailForm />
                            <PlanBilling
                                isLoading={isLoading}
                                subscriptionId={subscriptionId}
                                preSubscription={handlePreSubscription}
                                cancelSubscription={handleCancelSubscription}
                            />
                            {clientSecret && stripePromise && (
                                <Elements
                                    key={clientSecret}
                                    stripe={stripePromise}
                                    options={{ clientSecret }}
                                >
                                    <PaymentForm
                                        isLoading={isLoading}
                                        setIsLoading={setIsLoading}
                                    />
                                </Elements>
                            )}
                        </Main>
                    </Col>
                </Row>
            </Content>
        </StyledLayout>
    )
}

export default Profile
